module.exports = __webpack_public_path__ + "static/media/and-out-of-the-caves-the-night-threw-a-handful-of-pale-tumbling-pigeons-in-the-light.b726da29.jpg";